<script lang="ts" setup>
import LayoutDefault from '~/layout/default.vue'
import { useAccountStore } from '../../shared/store/store.account'
import { getCategories, getProfileData } from '@caks/shared/api/user.route'
import uuid4 from 'uuid4'
import { CustomToast } from '@caks/uikit/toast'
import { ElementCart } from '~/components/element'

const store = useAccountStore()

onMounted(async () => {
  const savedCart = localStorage.getItem('cart')
  const promo = localStorage.getItem('promo')
  const location = localStorage.getItem('location')

  if (savedCart) store.cart = JSON.parse(savedCart)
  if (location) store.selectedLocation = JSON.parse(location)
  if (promo) store.setPromo(JSON.parse(promo))

  const watchedStories = localStorage.getItem('wathed-stories')

  if (watchedStories) {
    const ids: string[] = JSON.parse(watchedStories)
    if (ids) store.watchedStoriesIds = ids.map((el) => +el)
  } else {
    store.watchedStoriesIds = []
  }

  const { data: profileData, status } = await getProfileData()
  if (status === 'OK') {
    store.setProfile(profileData)
  } else {
    if (!sessionStorage.getItem('guestToken')) {
      let uuid = uuid4()

      sessionStorage.setItem('guestToken', `guest_${uuid}`)
    }
  }

  const { data: categoriesData } = await getCategories()
  store.categories = categoriesData.map((el) => {
    return {
      id: el.id,
      name: el.name,
    }
  })
})
</script>

<template>
  <client-only>
    <layout-default>
      <router-view />
      <element-cart />
    </layout-default>
    <custom-toast desktop />
  </client-only>
</template>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.leaflet-control-attribution.leaflet-control {
  display: none;
}
body._locked {
  scrollbar-gutter: stable;
  overflow: hidden;
}
html,
body {
  scrollbar-gutter: stable;
}
</style>
